// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './pathify/store'
import router from './router'
import Vuetify from 'vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'vuetify/dist/vuetify.min.css'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import VueSweetalert2 from 'vue-sweetalert2'
import VueClipboard from 'vue-clipboard2'
import VueSocketio from 'vue-socket.io'
import VueQr from 'vue-qr'
import * as VueGoogleMaps from 'vue2-google-maps'
import '../static/fonts/Kanit/stylesheet.css'
// import '../static/fonts/Athiti/stylesheet.css'
// import '../static/fonts/Poppins/stylesheet.css'
// import '../static/fonts/THSarabun/stylesheet.css'
import '../static/fonts/CSChatThai/stylesheet.css'
// import '../static/fonts/Maitree/stylesheet.css'
import VueQrcodeReader from 'vue-qrcode-reader'
import VueCookie from 'vue-cookie'
import ReadMore from 'vue-read-more'
import LinkPreview from '@ashwamegh/vue-link-preview'
// import * as firebase from "firebase/app";
// import "firebase/firestore";
// import "firebase/analytics";
import vueHeadful from 'vue-headful'
import player from 'vue-hls-player'
Vue.use(player)

// import VueI18n from 'vue-i18n'
// import { i18n } from '../static/dictionary/lang.js'
// import i18n from '@/plugins/lang.js'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import { languages } from './plugins/lang.js'
import { defaultLocale } from './plugins/lang.js'
const messages = Object.assign(languages)

// const firebaseConfig = {
//   apiKey: "AIzaSyDliKV5rvjsLNNK_AxSrcRl5sDUMS_hQF8",
//   authDomain: "onechat-de3fe.firebaseapp.com",
//   databaseURL: "https://onechat-de3fe.firebaseio.com",
//   projectId: "onechat-de3fe",
//   storageBucket: "onechat-de3fe.appspot.com",
//   messagingSenderId: "501136854127",
//   appId: "1:501136854127:web:5b2629b97804c79169919a",
//   measurementId: "G-95176H8WVQ"
// };
// Initialize Firebase
// const init = firebase.initializeApp(firebaseConfig);
// const analytic = firebase.analytics();
// analytic.logEvent('notification_received');
// analytic.logEvent('goal_completion', { name: 'lever_puzzle'});

// firebase.initializeApp(firebaseConfig);
// firebase.analytics();

Vue.config.productionTip = false
Vue.config.devtools = true
Vue.config.performance = true
// alias
// Vue.prototype.$analytics = firebase.analytics()


// Vue.use(VueI18n)
// Vue.component('vue-headful', vueHeadful)
Vue.use(vueHeadful)
Vue.use(ReadMore)
Vue.use(VueCookie)
Vue.use(VueQrcodeReader)
Vue.use(Vuetify)
Vue.use(VueQr)
Vue.use(VueAxios, axios)
Vue.use(moment)
Vue.use(momentTimezone)
Vue.use(VueSweetalert2)
Vue.use(VueClipboard)
Vue.use(VueSocketio, process.env.APIsocket)
Vue.use(VueGoogleMaps, {
  load: {
    placeid: 'ChIJ4ZnvKX274jARFsZN_d404sI',
    key: 'AIzaSyBUh61FWG3kr4BSAEO_NRrniSz8S5ceLic',
    libraries: 'places' // necessary for places input
  }
})

Vue.use(LinkPreview)


// const i18n = new VueI18n({
//   locale: 'en', // set locale
//   messages, // set locale messages
// })

// Vue.config.productionTip = false

var i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'th',
  messages
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js